import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import AreasWeServe from "@/components/site/AreasWeServe";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import EarlyAccessModal from "@/components/site/EarlyAccessModal";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-white text-slate-900">
      <Header />
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <AreasWeServe />
      <Contact />
      <Footer />
      <EarlyAccessModal />
    </main>
  );
}
